import { createReducer } from "@reduxjs/toolkit";
import initialState from "./licensing.store";
import { activateLicenseKeyFailure, activateLicenseKeySuccessful, deactivateLicenseKeyFailure, deactivateLicenseKeySuccessful, loadLicensesListSuccessful, resetActivationError, setLicensingModalOpen, setLicensingModalType, setSeats, toggleNoSeatsToastVisible, changeSeatToastVisibleStatus, uploadActivationLicenseFileFailure, uploadActivationLicenseFileSuccessful, uploadDeactivationLicenseFileFailure, uploadDeactivationLicenseFileSuccessful, uploadDeactivationLicenseFile, } from "./licensing.actions";
import { LicensingModalType } from "./licensing.types";
export default createReducer(initialState, (builder) => {
    builder
        .addCase(setLicensingModalOpen, (state, { payload }) => {
        state.licensingModalOpen = payload;
    })
        .addCase(setLicensingModalType, (state, { payload }) => {
        state.licensingModalType = payload;
    })
        .addCase(loadLicensesListSuccessful, (state, { payload: { licenses, serialNumber, seats } }) => {
        state.licenses = licenses;
        state.serialNumber = serialNumber;
        state.seats.availableSeats = seats.availableSeats;
        state.seats.busySeats = seats.busySeats;
    })
        .addCase(activateLicenseKeyFailure, (state, { payload }) => {
        state.serverError = payload;
    })
        .addCase(deactivateLicenseKeyFailure, (state, { payload }) => {
        state.serverError = payload;
    })
        .addCase(uploadActivationLicenseFileFailure, (state, { payload }) => {
        state.serverError = payload;
    })
        .addCase(uploadActivationLicenseFileSuccessful, (state) => {
        state.serverError = null;
        state.licensingModalType = LicensingModalType.LIST;
    })
        .addCase(uploadDeactivationLicenseFile, (state) => {
        state.deactivationFinished = false;
        state.serverError = null;
    })
        .addCase(uploadDeactivationLicenseFileSuccessful, (state) => {
        state.deactivationFinished = true;
    })
        .addCase(uploadDeactivationLicenseFileFailure, (state, { payload }) => {
        state.serverError = payload;
        state.deactivationFinished = true;
    })
        .addCase(activateLicenseKeySuccessful, (state) => {
        state.serverError = null;
        state.licensingModalType = LicensingModalType.LIST;
    })
        .addCase(deactivateLicenseKeySuccessful, (state) => {
        const noLicenses = !state.licenses || state.licenses.length === 0;
        state.serverError = null;
        state.licensingModalType = noLicenses ? LicensingModalType.ACTIVATION : LicensingModalType.LIST;
    })
        .addCase(resetActivationError, (state) => {
        state.serverError = null;
        state.capabilityRequestError = null;
        state.deactivationFinished = null;
    })
        .addCase(setSeats, (state, { payload: { availableSeats, busySeats, isLastSeat } }) => {
        state.seats.availableSeats = availableSeats;
        state.seats.busySeats = busySeats;
        state.seats.isLastSeat = isLastSeat;
    })
        .addCase(toggleNoSeatsToastVisible, (state, { payload }) => {
        state.noSeatsAvailableToastVisible = payload;
    })
        .addCase(changeSeatToastVisibleStatus, (state, { payload }) => {
        state.seatToastVisibleStatus = payload;
    });
});
